import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link , useHistory} from "react-router-dom"
import { isEmpty, result, size } from "lodash"
import * as moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import classNames from "classnames"
import { AvForm, AvField } from "availity-reactstrap-validation"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getExpenseList } from "helpers/backend_helper"
import { deletePurchasePaymentEntry } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
//import SalesListFilter from "../../components/Common/SalesListFilter"

const ExpenseList = props => {
  const history = useHistory()
  const modeOptions = [
    {
      label: "Cash",
      value: "cash"
    },{
      label: "Electronic Transfer",
      value: "etrans"
    },{
      label: "Cheque / DD",
      value: "cheque"
    }
  ]

  useEffect(() => {
    getExpenseListLocal()
  }, []);

  async function getExpenseListLocal(){
    setShowLoading(true)
    getExpenseList().then(result => {
      setExpenseList(result)
      setShowLoading(false)
    })
  }

  function getModeLabel(inp){
    const opt = modeOptions.filter(each =>each.value = inp)
    if(opt.length > 0){
      return opt[0].label
    }
  }

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [currentReceipt, setCurrentReceipt] = useState({})

  const [expenseList, setExpenseList] = useState([])
  const [selectedRow, setSelectedRow] = useState()

  const [searchInProgress, setSearchInProgress] = useState(false)

  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  const [showReceipt, setShowReceipt] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: size(expenseList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }

  const { SearchBar } = Search

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const ExpenseListColumns = () => [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "receiptdate",
      text: "Receipt Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "toaccountid",
      text: "For",
      sort: true,
      //sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "paymentaccountid",
      text: "From",
      sort: true,
    },
    {
      dataField: "cashpaid",
      text: "Amount",
      sort: true,
      formatter: (cellContent, row) => (
      <div>
        {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
      </div>
      ),
    },
    {
      dataField: "mode",
      text: "Mode",
      sort: true,
      formatter: (cellContent, row) => (
        <div>
          {getModeLabel(cellContent)}
        </div>
        ),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: (cellContent, row) => (
        <div>
          {(cellContent)}
        </div>
        ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop pointer-cursor"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={() => handleEditClick(item)}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              Edit
            </DropdownItem>
            <DropdownItem
              onClick={() => handleDeleteClick(item)}
            >
              <i className="bx bx-trash-alt font-size-16 text-danger me-1" />{" "}
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.toaccountid)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)

    const response =  await onDeleteItemDirect({
      'key': itemToDelete.id,
      'value' : 'Expense'
    }, '')

    setShowLoading(false)
    if(response.status == 'success'){
      showSuccessToast('Deleted Successfully!!!')
      getExpenseListLocal()
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const selectRow = {
    mode: 'radio',
    hideSelectColumn: true,
    clickToSelect: true,
    bgColor: '#e8e2d7',
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelectedRow(row)
      setShowReceipt(true)
    }
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  function hideReceipt(){
    setShowReceipt(false)
  }

  const [filterApplied, setFilterApplied] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState({})
  const [searchDispCriteria, setSearchDispCriteria] = useState({
    customername: 'All',
    status : 'Any'
  })

  function onSearch(searchCritiria){
    setSearchCriteria(searchCritiria)
    setSearchInProgress(true)
    getExpenseList(searchCritiria).then(result => {
      setExpenseList(result)
      setSearchInProgress(false)
    })
  }

  const toggle = () => {
    setModal(!modal)
  }

  const handleEditClick = arg => {
    history.push('/list-expenses/'+arg.id)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Expenses | Flamingo</title>
        </MetaTags>
        {!showReceipt && <Container fluid>
          <Breadcrumbs title="Expense" breadcrumbItem="All Expenses" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={ExpenseListColumns()}
                    data={expenseList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={expenseList}
                        columns={ExpenseListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="6">
                              <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="6">
                                <div className="text-sm-end">
                                  <Link
                                    to="/add-expense-payment"
                                    role="button"
                                    className="btn btn-success btn-rounded  mb-2 me-2"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Expense
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive min-height-200">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    //selectRow={selectRow}
                                    bordered={false}
                                    striped={false}
                                    //defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-hover"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={<div className="text-center">- No results found -</div>}
                                  />
                                </div>
                                
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>}

      </div>

      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Expense entry for : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

ExpenseList.propTypes = {
  expenseList: PropTypes.array,
}

export default withRouter(ExpenseList)
